module.exports = __webpack_public_path__ + "assets/item-comment.df4b0fc5.svg";